<template>
  <div class="min-h-screen bg-white flex">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 shadow-xl">
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <slot name="logo"/>
        </div>
        <div class="mt-6">
          <slot/>
        </div>
      </div>
      <div class="mx-auto pt-5">
        <LanguageSelector></LanguageSelector>
      </div>
    </div>
    <div class="hidden lg:block relative w-0 flex-1 shadow-inner">
      <img class="absolute inset-0 h-full w-full object-cover" src="/images/banner/auth_banner.jpg" alt="">
    </div>
  </div>
</template>
<script setup>
import LanguageSelector from "../Components/LanguageSelector.vue";
</script>